import useAccessControls from 'modules/access-controls/atoms/use-access-controls';
import {CompanyProps} from 'modules/companies/types';
import useArriveOrder from 'modules/orders/hooks/use-arrive-order';
import useDeliveryOrder from 'modules/orders/hooks/use-delivery-order';
import useFinishOrder from 'modules/orders/hooks/use-finish-order';
import usePrepareOrder from 'modules/orders/hooks/use-prepare-order';
import usePreparedOrder from 'modules/orders/hooks/use-prepared-order';
import useReadyToDelivery from 'modules/orders/hooks/use-ready-to-delivery';
import {OrderStatus, OrderTypeEnum} from 'modules/orders/types';
import getOrderNextStatusColor from 'modules/orders/util/get-order-next-status-color';
import React from 'react';
import {FaUserClock} from 'react-icons/fa';
import {IoCheckmark, IoHome} from 'react-icons/io5';
import {MdDeliveryDining} from 'react-icons/md';
import {PiForkKnifeFill} from 'react-icons/pi';
import IconButton from 'shared/migration-components/icon-button';

interface Props {
  orderId: string;
  currentStatusName: OrderStatus;
  type: OrderTypeEnum;
  company: CompanyProps;
}

const NextStatusButton: React.FC<Props> = ({
  orderId,
  currentStatusName,
  type,
  company,
}) => {
  const {companyId} = useAccessControls();
  const prepareOrderMutation = usePrepareOrder(orderId);
  const deliveryOrderMutation = useDeliveryOrder(orderId);
  const preparedOrderMutation = usePreparedOrder(orderId);
  const finishOrderMutation = useFinishOrder(orderId);
  const readyToDeliveryMutation = useReadyToDelivery(orderId);
  const arriveOrderMutation = useArriveOrder(orderId);

  const color = getOrderNextStatusColor({currentStatusName, company, type});

  if (currentStatusName === 'opened')
    return (
      <IconButton
        label="Aceitar pedido"
        backgroundColor={color}
        icon={<PiForkKnifeFill />}
        loading={prepareOrderMutation.isLoading}
        onClick={() => prepareOrderMutation.mutate(undefined)}
      />
    );

  if (currentStatusName === 'preparing' && type === OrderTypeEnum.pickup)
    return (
      <IconButton
        label="Avisar cliente"
        backgroundColor={color}
        color="white"
        icon={<FaUserClock />}
        loading={preparedOrderMutation.isLoading}
        onClick={() => preparedOrderMutation.mutate(undefined)}
      />
    );

  if (
    currentStatusName === 'preparing' &&
    type !== OrderTypeEnum.pickup &&
    !company.deliveryByCompany
  )
    return (
      <IconButton
        label="Chamar entregador"
        backgroundColor={color}
        color="white"
        icon={<MdDeliveryDining />}
        loading={readyToDeliveryMutation.isLoading}
        onClick={() => readyToDeliveryMutation.mutate(undefined)}
      />
    );

  if (
    currentStatusName === 'preparing' &&
    type !== OrderTypeEnum.pickup &&
    company.deliveryByCompany
  )
    return (
      <IconButton
        label="Saiu pra entrega"
        backgroundColor={color}
        color="white"
        icon={<MdDeliveryDining />}
        loading={deliveryOrderMutation.isLoading}
        onClick={() => deliveryOrderMutation.mutate(undefined)}
      />
    );

  if (
    currentStatusName === 'delivering' &&
    !company.deliveryByCompany &&
    !companyId
  )
    return (
      <IconButton
        label="Avisar cliente"
        backgroundColor={color}
        color="white"
        icon={<IoHome />}
        loading={arriveOrderMutation.isLoading}
        onClick={() => arriveOrderMutation.mutate(undefined)}
      />
    );

  if (
    currentStatusName === 'ready_to_pickup' ||
    (!companyId && currentStatusName === 'arrival') ||
    (currentStatusName === 'delivering' && company.deliveryByCompany)
  )
    return (
      <IconButton
        label="Finalizar"
        backgroundColor={color}
        color="white"
        icon={<IoCheckmark />}
        loading={finishOrderMutation.isLoading}
        onClick={() => finishOrderMutation.mutate(undefined)}
      />
    );

  return null;
};

export default NextStatusButton;
